// ForgotPassword.jsx
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { authAPI } from '../../api'
import { RiMailLine, RiLoader4Line, RiCheckLine } from 'react-icons/ri'
import { useState } from 'react'
import toast from 'react-hot-toast'

export function ForgotPassword() {
  const [sent, setSent] = useState(false)
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm()

  const onSubmit = async (data) => {
    try {
      await authAPI.forgotPassword(data)
      setSent(true)
    } catch {
      toast.error('Something went wrong. Please try again.')
    }
  }

  if (sent) return (
    <div className="text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
        <RiCheckLine className="text-green-600 text-2xl" />
      </div>
      <h2 className="font-display text-salon-dark text-2xl font-bold mb-2">Check your email</h2>
      <p className="text-salon-muted font-body text-sm mb-6">We've sent a password reset link to your email.</p>
      <Link to="/login" className="btn-primary inline-flex">Back to Login</Link>
    </div>
  )

  return (
    <div>
      <h1 className="font-display text-salon-dark text-3xl font-bold mb-2">Forgot Password</h1>
      <p className="text-salon-muted font-body text-sm mb-8">Enter your email and we'll send a reset link.</p>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <div>
          <label className="input-label">Email Address</label>
          <div className="relative">
            <RiMailLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('email', { required: true, pattern: /^\S+@\S+\.\S+$/ })}
              className="input-field pl-10" placeholder="you@example.com" type="email" />
          </div>
        </div>
        <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center">
          {isSubmitting ? <><RiLoader4Line className="animate-spin" /> Sending...</> : 'Send Reset Link'}
        </button>
      </form>
      <p className="text-center text-sm font-body text-salon-muted mt-6">
        <Link to="/login" className="text-salon-primary font-semibold hover:underline">← Back to login</Link>
      </p>
    </div>
  )
}

export default ForgotPassword
